import React from 'react';
import Grid from 'components/atoms/Grid';
import Form from 'components/molecules/Form';
import Field from 'components/molecules/Field';

const ClientDetails = ({ isView, shippingAddresses, addAddress, removeAddress }) => {
  return (
    <div className="section-card">
      <h3 className="section-title">Estimate &amp; Client Details</h3>
      <Grid xs={1} lg={4} colGap={16} className="mt-3">
        <Form.Item sm label="Client Name" name="clientName" placeholder="Enter client name">
          <Field disabled={isView} />
        </Form.Item>
        <Form.Item sm label="Company Name" name="companyName" placeholder="Enter company name">
          <Field disabled={isView} />
        </Form.Item>
        <Form.Item sm label="Email" name="email" placeholder="Enter email">
          <Field disabled={isView} />
        </Form.Item>
        <Form.Item sm label="Phone" name="phone" placeholder="Enter phone">
          <Field disabled={isView} />
        </Form.Item>
      </Grid>
      <div className="shipping-addresses-section">
        <div className="d-flex align-items-center justify-content-between mb-20">
          <span>Shipping Addresses</span>
          {!isView && (
            <button type="button" className="d-flex align-items-center gap-1 btn-add" onClick={addAddress}>
              <i className="material-icons-outlined">add</i>
              Add Address
            </button>
          )}
        </div>
        {shippingAddresses?.map((addr, idx) => (
          <div key={addr?.id} className="address-holder">
            <Grid xs={1} lg={2} colGap={16} key={addr?.id}>
              <Form.Item
                type="textarea"
                label={`Shipping Address ${idx + 1}`}
                name={`shippingAddress_${idx}`}
                placeholder="Enter shipping address">
                <Field disabled={isView} />
              </Form.Item>
              <Form.Item
                type="textarea"
                label={`Shipping Details ${idx + 1}`}
                name={`shippingDetails_${idx}`}
                placeholder="Enter shipping details">
                <Field disabled={isView} />
              </Form.Item>
            </Grid>
            {shippingAddresses.length > 1 && !isView && (
              <button type="button" className="btn-remove-address" onClick={() => removeAddress(addr.id)}>
                <i className="material-icons-outlined">delete_outline</i>
              </button>
            )}
          </div>
        ))}
      </div>

      <Form.Item type="textarea" label="Project Details" name="project_details" placeholder="Enter project details">
        <Field disabled={isView} />
      </Form.Item>
    </div>
  );
};

export default ClientDetails;
